import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import ChartTab from "./ChartTab";
import axios from "./../../utils/axiosInstance";

const StatisticsChart = () => {
  const getPreviousMonths = (currentMonthIndex, monthsToCalculate) => {
    const MONTHS = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const previousMonths = [];

    for (let i = 0; i < monthsToCalculate; i++) {
      const monthIndex = (currentMonthIndex + i + 1) % 12; // Wrap around using modulo
      previousMonths.push(MONTHS[monthIndex]);
    }

    return previousMonths;
  };

  const currentMonthIndex = new Date().getMonth(); // April (index 3)
  const previousMonths = getPreviousMonths(currentMonthIndex, 12); // Get last 12 months

  const options = {
    legend: {
      show: true, // Hide legend
      position: "top",
      horizontalAlign: "left",
    },
    colors: ["#465FFF", "#9CB900"], // Define line colors
    chart: {
      fontFamily: "Outfit, sans-serif",
      height: 310,
      type: "line", // Set the chart type to 'line'
      toolbar: {
        show: true, // Hide chart toolbar
      },
    },
    stroke: {
      curve: "straight", // Define the line style (straight, smooth, or step)
      width: [2, 2], // Line width for each dataset
    },

    fill: {
      type: "gradient",
      gradient: {
        opacityFrom: 0.55,
        opacityTo: 0,
      },
    },
    markers: {
      size: 0, // Size of the marker points
      strokeColors: "#fff", // Marker border color
      strokeWidth: 2,
      hover: {
        size: 6, // Marker size on hover
      },
    },
    grid: {
      xaxis: {
        lines: {
          show: true, // Hide grid lines on x-axis
        },
      },
      yaxis: {
        lines: {
          show: true, // Show grid lines on y-axis
        },
      },
    },
    dataLabels: {
      enabled: true, // Disable data labels
    },
    tooltip: {
      enabled: true, // Enable tooltip
      x: {
        format: "dd MMM yyyy", // Format for x-axis tooltip
      },
    },
    xaxis: {
      type: "category", // Category-based x-axis
      categories: previousMonths,
      axisBorder: {
        show: false, // Hide x-axis border
      },
      axisTicks: {
        show: false, // Hide x-axis ticks
      },
      tooltip: {
        enabled: false, // Disable tooltip for x-axis points
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: "12px", // Adjust font size for y-axis labels
          colors: ["#6B7280"], // Color of the labels
        },
      },
      title: {
        text: "", // Remove y-axis title
        style: {
          fontSize: "0px",
        },
      },
    },
  };

  const [series, setSeries] = useState([
    {
      name: "Customers",
      data: [],
    },
    {
      name: "Revenue",
      data: [],
    },
  ]);

  useEffect(() => {
    const fetchStatistics = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASED_URL}/stats/statistics`
        );
        const customersData = response.data.customers;
        const earningsData = response.data.earnings;

        setSeries([
          {
            name: "Customers",
            data: customersData,
          },
          {
            name: "Revenue",
            data: earningsData,
          },
        ]);
      } catch (error) {
        console.error(error);
      }
    };

    fetchStatistics();
  }, []);

  return (
    <div className="rounded-2xl border border-gray-200 bg-white px-5 pb-5 pt-5 dark:border-gray-800 dark:bg-white/[0.03] sm:px-6 sm:pt-6">
      {/* <div className="flex flex-col gap-5 mb-6 sm:flex-row sm:justify-between">
                <div className="w-full">
                    <p className="mt-1 text-gray-500 text-theme-sm dark:text-gray-400">
                        Target you’ve set for each month
                    </p>
                </div>
                <div className="flex items-start w-full gap-3 sm:justify-end">
                    <ChartTab />
                </div>
            </div> */}

      <div className="max-w-full overflow-x-auto custom-scrollbar">
        <div className="min-w-[1000px] xl:min-w-full">
          <Chart options={options} series={series} type="area" height={310} />
        </div>
      </div>
    </div>
  );
};

export default StatisticsChart;
